/* Consent card → Shopify Customer Privacy API. Shows only where Shopify says a banner is required
   (store's privacy settings), or with ?consent=1 for testing. Remembers dismissal locally as well. */
(function () {
  'use strict';
  const el = document.querySelector('[data-rr-consent]'); if (!el) return;
  const force = /[?&]consent=1/.test(location.search);
  const KEY = 'rr-consent-v1';
  let stored = null; try { stored = localStorage.getItem(KEY); } catch (e) {}
  if (stored && !force) return;

  const prefs = el.querySelector('[data-rr-consent-prefs]');
  const save = el.querySelector('[data-rr-consent-save]');
  const q = s => el.querySelector(s);
  const boxes = () => Object.fromEntries([...prefs.querySelectorAll('input[name]')].map(i => [i.name, i.checked]));

  function apply(consent) {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    const payload = { analytics: !!consent.analytics, marketing: !!consent.marketing, preferences: !!consent.preferences, sale_of_data: !!consent.marketing };
    if (cp && cp.setTrackingConsent) cp.setTrackingConsent(payload, () => {});
    try { localStorage.setItem(KEY, JSON.stringify({ ...payload, at: Date.now() })); } catch (e) {}
    el.hidden = true;
  }
  q('[data-rr-consent-accept]').addEventListener('click', () => apply({ analytics: true, marketing: true, preferences: true }));
  q('[data-rr-consent-deny]').addEventListener('click', () => apply({ analytics: false, marketing: false, preferences: false }));
  q('[data-rr-consent-customize]').addEventListener('click', e => { prefs.hidden = false; save.hidden = false; e.currentTarget.hidden = true; });
  save.addEventListener('click', () => apply(boxes()));

  function show() { el.hidden = false; }
  function decide() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (force) return show();
    if (!cp || !cp.shouldShowBanner) return;               // API unavailable: stay quiet rather than nag
    if (cp.shouldShowBanner()) show();
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => { if (!err) decide(); else if (force) show(); });
  } else if (force) show();
})();
